export default "__VITE_ASSET__CwcT7kFc__"